import { render } from "./SecretG.vue?vue&type=template&id=920e989c&scoped=true"
import script from "./SecretG.vue?vue&type=script&lang=js"
export * from "./SecretG.vue?vue&type=script&lang=js"

import "./SecretG.vue?vue&type=style&index=0&id=920e989c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-920e989c"]])

export default __exports__